import type { FunctionComponent } from 'react';
import LoadingSection from '../../LoadingSection/LoadingSection';
import { PerksListContainer, PRICE_ID_CONTAINER } from '../shared';
import { SeasonalPlanCardProps } from '../shared/interfaces';
import * as styles from '../shared/SharedPlanStyles.module.scss';
import * as seasonalStyles from './SeasonalPlanCard.module.scss';

const SeasonalPlanCard: FunctionComponent<SeasonalPlanCardProps> = ({
  perksList,
  title,
  disclaimer,
  price,
  isLoadingPrice,
  onSelectPlan,
  isSelected,
  subtitle,
}) => {
  return (
    <div
      onClick={onSelectPlan}
      role="button"
      tabIndex={0}
      onKeyDown={onSelectPlan}
      id="seasonal-plan"
      className={`
          ${styles.planCardContainer}
          ${isSelected ? styles.plansOptionsSelected : ''}
        `}
      data-testid="seasonal-plan-select"
    >
      <div className={styles.planSelectedLabel}>Selected Plan</div>
      <div className={styles.plansContent}>
        <div className={styles.plansPriceContainer}>
          <div className={styles.plansTitle}>
            <h4>{title}</h4>
          </div>
          <p className={seasonalStyles.planSubTitle}>{subtitle}</p>
          <p data-testid={PRICE_ID_CONTAINER} className={styles.plansContentPrice}>
            ${!isLoadingPrice ? price : <LoadingSection height={42} width={125} />} <span>USD</span>
          </p>
          <div className={seasonalStyles.planDisclaimer}>{disclaimer}</div>
        </div>
        <hr className={styles.plansLineDivider} />
        <PerksListContainer perksList={perksList} />
      </div>
    </div>
  );
};

export default SeasonalPlanCard;
